// Route: /courses/$courseId — воркспейс курса (Course Workspace V2 §4.1).
//
// РЕДИРЕКТА НА ТЕКУЩУЮ ТЕМУ ЗДЕСЬ НЕТ (декрет E10, отменяет §4.1 плана):
// роут рендерит тот же воркспейс с `activeTopicId = course.currentTopic`, а
// URL темы остаётся каноническим для deep-link, но переход на него — только по
// действию пользователя. Редирект сломал бы пустой и строящийся курс, ссылки
// `CourseCard` с дашборда и легаси-ссылки из писем.
//
// ВАЖНО: роут по-прежнему НЕ содержит <Outlet/> (декрет E9) — экран темы
// объявлен non-nested-файлом `$courseId_.topics.$topicId.tsx`, и оба роута
// рендерят ОДИН компонент `components/courses/workspace/course-workspace.tsx`.
//
// URL state — общая схема обоих роутов (`workspace/_search.ts`, декрет E11):
// ?view= · ?fmt= · ?note= · ?edit=1 · ?demo= · ?read= (@deprecated → view=note).

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute } from "@tanstack/react-router";
import { courseWorkspaceSearchSchema } from "@/components/courses/workspace/_search";
import {
	CourseWorkspace,
	CourseWorkspacePending,
} from "@/components/courses/workspace/course-workspace";

export const Route = createFileRoute("/courses/$courseId")({
	validateSearch: tolerantSearch(courseWorkspaceSearchSchema),
	component: CourseDetailPage,
	pendingComponent: CourseWorkspacePending,
});

function CourseDetailPage(): React.ReactElement {
	const { courseId } = Route.useParams();
	const search = Route.useSearch();
	return <CourseWorkspace courseId={courseId} routeTopicId={null} search={search} />;
}
